<script setup>
import Avatar from "primevue/avatar";
import Button from "primevue/button";
import InputText from "primevue/inputtext";
import Password from "primevue/password";
import Select from "primevue/select";

const form = defineModel()

const LOCALES = [
    { code: 'cs', label: 'Čeština', flag: '🇨🇿' },
    { code: 'en', label: 'English', flag: '🇬🇧' },
    { code: 'ko', label: '한국어',   flag: '🇰🇷' },
]
</script>

<template>
    <div class="w-full flex flex-col h-full">

        <div class="max-lg:mx-0 max-lg:pt-4  pt-0 grow flex gap-4 flex-wrap">
            <div class="flex flex-col items-start gap-1 grow">
                <label for="smtp_address" class="text-sm font-medium text-gray-700 dark:text-gray-300">{{ $t('settings.field_name') }}</label>
                <InputText id="smtp_address"
                           v-model="form.user_name"
                           fluid
                           @change="form.validate('user_name')"
                           :class="{'p-invalid': form.invalid('user_name')}">
                </InputText>
                <small v-if="form.invalid('user_name')" class="p-error">
                    {{ form.errors['user_name'] }}
                </small>
            </div>
            <div class="flex flex-col items-start gap-1 grow">
                <label for="smtp_address" class="text-sm font-medium text-gray-700 dark:text-gray-300">{{ $t('settings.field_password') }}</label>
                <Password id="smtp_address"
                          v-model="form.user_password"
                          fluid
                          class="w-full"
                          @change="form.validate('user_password')"
                          :class="{'p-invalid': form.invalid('user_password')}">
                </Password>
                <small :class="form.invalid('user_password') ? `p-error` : ''">
                    {{ form.errors['user_password'] ?? $t('settings.field_password_hint') }}
                </small>
            </div>
            <div class="flex flex-col items-start gap-1 grow">
                <label for="user_locale" class="text-sm font-medium text-gray-700 dark:text-gray-300">{{ $t('settings.field_language') }}</label>
                <Select id="user_locale"
                        v-model="form.user_locale"
                        :options="LOCALES"
                        option-label="label"
                        option-value="code"
                        fluid
                        @change="form.validate('user_locale')"
                        :class="{'p-invalid': form.invalid('user_locale')}">
                    <template #value="{ value }">
                        <span v-if="value">{{ LOCALES.find(l => l.code === value)?.flag }} {{ LOCALES.find(l => l.code === value)?.label }}</span>
                    </template>
                    <template #option="{ option }">
                        <span>{{ option.flag }} {{ option.label }}</span>
                    </template>
                </Select>
                <small v-if="form.invalid('user_locale')" class="p-error">
                    {{ form.errors['user_locale'] }}
                </small>
            </div>
            <div class="text-center w-full mt-8 relative">
                <div class=" absolute top-0 w-full z-10">
                    <p class="mb-2">{{ $t('settings.additional_settings') }}</p>
                    <a href="/profile" target="_blank">
                        <Button severity="contrast" :label="$t('settings.maeum_account')" size="small">
                            <template #icon>
                                <div class="flex flex-col items-center">
                                    <div class="flex flex-col items-center">
                                        <div class="maeum-short"></div>
                                        <div class="maeum-long"></div>
                                        <div class="maeum-short"></div>
                                    </div>
                                </div>
                            </template>
                        </Button>
                    </a>
                </div>
                <div class="flex items-center blur-xl opacity-70 w-full justify-center scale-125">
                    <div class="w-16 h-16 rounded-full bg-blue-500/60"></div>
                    <div class="w-14 h-14 rounded-full bg-purple-500/80 -mt-3 -ml-5"></div>
                    <div class="w-20 h-20 rounded-full bg-black/30 mt-3 -ml-5"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
.maeum-short {
    width: 8px;
    height: 2px;
    background: #fff;
}

.maeum-long {
    width: 16px;
    height: 2px;
    margin: 3px 0;
    background: #fff;
}

.dark .maeum-long, .dark .maeum-short {
    background: #000;
}
</style>
